<div
    id="{{ productId() }}"
    [class.no-clickable]="!config()?.clickable"
    [class.limited-card-wrap]="config()?.showLimitedAndDescription"
    [class.has-background-color]="productStyle()?.backgroundColo"
    [style.color]="productStyle()?.tintColor"
    [style.backgroundColor]="productStyle()?.backgroundColor"
    (outViewPort)="containerOutInView()"
    (inViewport)="containerIsInView()"
    [inViewportThreshold]="viewThreshold"
    [inViewportExtraOptions]="inViewportExtraOptions"
>
    @if (vm$$()) {
        <div
            class="product-cards-container"
            (inViewport)="productIsInOrOutView($event)"
            (outViewPort)="productIsInOrOutView($event)"
            [inViewportThreshold]="viewThreshold"
        >
            @for (image of vm$$().medias.images; track $index; let index = $index) {
                @if (image) {
                    <product-card
                        #productCard
                        [class.show-quickly-active]="showQuicklyisActive"
                        [videoUrl]="vm$$().medias.videos[$index]?.path"
                        [imageUrl]="image?.path"
                        [productImages]="vm$$().medias.productImages"
                        [linkHref]="vm$$().product?.locationPath"
                        [hasInView]="hasInView"
                        [config]="templateConfig[index] ?? vm$$().templateConfig"
                        (clickMedia)="loadProduct($event, vm$$())"
                        (mediaError)="onMediaError()"
                    >
                        <div productCardBadge>
                            @defer (on viewport(productCard); when showContentProjected) {
                                <product-view-badge
                                    [product]="vm$$().product"
                                    [config]="vm$$().templateConfig"
                                    [prices]="vm$$().prices"
                                    [categoryConfig]="categoryConfig()"
                                    (onActionBadge)="viewBadgeAction($event, vm$$())"
                                    (addToCartEvent)="addToCart($event)"
                                    (showAvailabilityEvent)="showAvailability($event)"
                                >
                                </product-view-badge>

                                <!-- Información de depuración -->
                                @if (isDebugBarShowProductInfoActive$$()) {
                                    <product-debug
                                        [product]="vm$$().product"
                                        [templateConfig]="vm$$().templateConfig"
                                        [defaultImageType]="defaultImageType()"
                                    ></product-debug>
                                }
                            }
                        </div>
                    </product-card>
                } @else {
                    <media-skeleton [ratio]="ratio" [skeletonTextPosition]="config()?.textPosition"></media-skeleton>
                }
            }
        </div>

        <product-view-footer
            [product]="vm$$().product"
            [config]="vm$$().templateConfig"
            [prices]="vm$$().prices"
            [productStyle]="productStyle()"
            [categoryConfig]="categoryConfig()"
            (navigate)="loadProduct($event, vm$$())"
        ></product-view-footer>
    } @else {
        <!-- TODO Tribu imagen arreglar SSR -->
        <!-- <media-skeleton [ratio]="ratio" [skeletonTextPosition]="config()?.textPosition"></media-skeleton> -->
    }
</div>
